export default __webpack_public_path__ + "static/media/phone-call.e180cfcb.png";